import MetaJSON from "./src/core";

export default MetaJSON;
